<footer class="footer d-none">
  <div class="container-fluid">
    <nav class="pull-left">
      <ul>
        <li>
          <a href="#"> Terms & Conditions </a>
        </li>
        <li>
          <a href="#"> Legal terms </a>
        </li>
        <li>
          <a href="#"> Licenses </a>
        </li>
      </ul>
    </nav>
    <div class="copyright pull-right d-none">
      Made with <i class="fa fa-heart heart"></i> by
      <a href="https://idesoftbcn.com/">Idesoftbcn</a>&nbsp;&copy;
      {{ test | date : "yyyy" }}
    </div>
  </div>
</footer>
